<template>
    <div class="tarifa">
        <v-container grid-list-xl fluid class="pt-0">
            <v-layout row wrap>
                <v-flex sm4 v-if="cicloExpand">
                    <v-card>
                        <v-toolbar color="primary" dark flat>
                            <v-toolbar-title>
                                <v-icon medium>fa-cog</v-icon>
                                Detalles del Ciclo
                            </v-toolbar-title>
                            <v-divider class="mx-2" inset vertical></v-divider>

                            <v-spacer></v-spacer>
                            <v-toolbar-items>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn icon color="primary" dark @click="cicloExpand = false">
                                            <v-icon v-on="on">{{ getCicloSeccionIcon() }}</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Ocultar</span>
                                </v-tooltip>
                            </v-toolbar-items>
                        </v-toolbar>

                        <v-card-text>
                            <v-container fluid grid-list-xl>
                                <v-layout align-center wrap>
                                    <v-flex tag="strong" sm5 text-xs-right mr-2>Nombre:</v-flex>
                                    <v-flex sm5>{{ cicloData ? cicloData.nombre : "-" }}</v-flex>
                                    <v-flex tag="strong" sm5 text-xs-right mr-2>Descripción:</v-flex>
                                    <v-flex sm5>{{ cicloData ? cicloData.descripcion : "-" }}</v-flex>
                                    <v-flex tag="strong" sm5 text-xs-right mr-2>Fecha inicio:</v-flex>
                                    <v-flex sm5>{{
                                        cicloData ? cicloData.mes_inicio + "/" + cicloData.anyo_inicio : "-"
                                    }}</v-flex>
                                    <v-flex tag="strong" sm5 text-xs-right mr-2>Fecha fin:</v-flex>
                                    <v-flex sm5>{{
                                        cicloData ? cicloData.mes_fin + "/" + cicloData.anyo_fin : "-"
                                    }}</v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-flex>

                <v-flex :class="cicloExpand ? 'sm8' : 'sm12'">
                    <v-card>
                        <v-toolbar color="primary" dark flat>
                            <v-scroll-x-transition>
                                <template v-if="!cicloExpand">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-btn icon color="primary" dark @click="cicloExpand = true">
                                                <v-icon v-on="on">{{ getCicloSeccionIcon() }}</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Contraer</span>
                                    </v-tooltip>
                                </template>
                            </v-scroll-x-transition>

                            <v-toolbar-title>
                                <v-icon medium>fa fa-cog</v-icon>
                                Lista de Tarifas
                            </v-toolbar-title>

                            <v-divider class="mx-2" inset vertical></v-divider>

                            <v-flex sm3 class="pa-0" style="max-width: 190px">
                                <v-overflow-btn
                                    v-model="tarifaEstado"
                                    label="Ciclo"
                                    :items="[
                                        { text: 'Todas', value: '1' },
                                        { text: 'Habilitadas', value: '2' },
                                        { text: 'Deshabilitadas', value: '3' }
                                    ]"
                                    hide-details
                                    class="pa-0"
                                    @change="loadCiclo()"
                                >
                                    <template v-slot:item="data">
                                        <v-list-tile-content>
                                            <v-card-text class="pa-0 ">
                                                <v-icon
                                                    :color="getIconColor(data)"
                                                    class="pr-3"
                                                    v-if="data.item.value !== '1'"
                                                    >fa-list</v-icon
                                                >
                                                {{ data.item.text }}
                                            </v-card-text>
                                        </v-list-tile-content>
                                    </template>
                                </v-overflow-btn>
                            </v-flex>

                            <v-divider class="px-1" inset vertical></v-divider>

                            <v-spacer></v-spacer>

                            <v-toolbar-items>
                                <v-btn icon @click="toogleSearch()">
                                    <v-icon medium>fa-search</v-icon>
                                </v-btn>

                                <v-expand-x-transition>
                                    <v-text-field
                                        hide-details
                                        solo
                                        v-show="searchShow"
                                        v-model="filter.search"
                                        placeholder="Filtrar"
                                        class="hidden-sm-and-down pt-2"
                                    >
                                    </v-text-field>
                                </v-expand-x-transition>

                                <v-divider class="pa-2"></v-divider>

                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn icon flat @click="openForm(null)">
                                            <v-icon medium v-on="on">fa-plus</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Agregar Tarifa</span>
                                </v-tooltip>
                            </v-toolbar-items>
                        </v-toolbar>
                        <v-divider></v-divider>
                        <v-card-text class="pa-0">
                            <v-data-table
                                :headers="headers"
                                :loading="loading"
                                :pagination.sync="pagination"
                                :rows-per-page-items="pagination.rowsPerPageItems"
                                :total-items="totalItems"
                                :items="TARIFAS"
                                class="elevation-1"
                                item-key="id"
                            >
                                <v-progress-linear v-slot:progress color="green" indeterminate></v-progress-linear>
                                <template slot="items" slot-scope="props">
                                    <tr>
                                        <td>{{ props.item.nombre }}</td>
                                        <td>{{ props.item.grado ? props.item.nombre : "-" }}</td>
                                        <td>{{ props.item.monto ? props.item.monto : "-" }}</td>
                                        <td>
                                            {{ props.item.inscripcion ? props.item.inscripcion : "-" }} <br />
                                            {{
                                                props.item.reinscripcion
                                                    ? "(Reinscripción " + props.item.reinscripcion + ")"
                                                    : "-"
                                            }}
                                        </td>
                                        <td>
                                            <v-chip
                                                small
                                                dark
                                                :color="getChipColor(props.item)"
                                                style="font-size: 12px"
                                            >
                                                {{
                                                    props.item.status_description ? props.item.status_description : "-"
                                                }}
                                            </v-chip>
                                            <div class="action-column">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            flat
                                                            icon
                                                            color="orange"
                                                            :disabled="loading || menuLocked"
                                                            @click="openForm(props.item)"
                                                        >
                                                            <v-icon medium v-on="on">fa-edit</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Editar Sección</span>
                                                </v-tooltip>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            flat
                                                            icon
                                                            color="red"
                                                            :disabled="loading || menuLocked"
                                                            @click="deleteItem(props)"
                                                        >
                                                            <v-icon medium v-on="on">fa-trash</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Eliminar Sección</span>
                                                </v-tooltip>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            flat
                                                            icon
                                                            color="grey"
                                                            :loading="loadingHistory"
                                                            :disabled="loading || menuLocked"
                                                            @click="loadHistory(props.item)"
                                                        >
                                                            <v-icon medium v-on="on">fa-archive</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Ver historial</span>
                                                </v-tooltip>
                                            </div>
                                        </td>
                                    </tr>
                                </template>
                                <template v-slot:expand="props">
                                    <v-card>
                                        <v-card-text class="py-0 pl-0 text-xs-right">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn icon flat color="red" @click="deleteItemCancel(props)">
                                                        <v-icon v-on="on">fa-close</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Cancelar acción</span>
                                            </v-tooltip>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn icon flat color="green" @click="deleteItemConfirm(props)">
                                                        <v-icon v-on="on">fa-check</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Confirmar acción</span>
                                            </v-tooltip>
                                        </v-card-text>
                                    </v-card>
                                </template>
                                <template slot="no-data">
                                    <div style="text-align: center">
                                        No existen tarifas registradas en el sistema.
                                    </div>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <tarifa-form
            v-if="showForm"
            :form-title="title"
            :initial-item="editItem"
            :ciclo-id="cicloId"
            @formCanceled="closeForm"
        >
        </tarifa-form>

        <time-line
            v-if="showHistory"
            :data="historyData"
            :element="'Tarifa'"
            @formCanceled="showHistory = false"
        ></time-line>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import _ from "lodash"
import Util from "@/util"
const TimeLine = () => import("@/components/widgets/records-time-line/time-line")
const TarifaForm = () => import("@/components/cobranza/nomencladores/tarifa-form/tarifa-form")

export default {
    components: { TarifaForm, TimeLine },
    props: {
        cicloParam: { type: Object, default: null }
    },
    data: () => ({
        searchShow: false,
        loading: false,
        title: "",
        showForm: false,
        headers: [
            { text: "Nombre", value: "nombre" },
            { text: "Grado", sortable: false },
            { text: "Monto", value: "monto" },
            { text: "Inscripción", value: "inscripcion" },
            { text: "Estado", value: "estado" }
        ],
        editItem: null,
        filter: {
            search: ""
        },
        totalItems: 0,

        deleteTarifaConfirmId: "",

        menuLocked: false,

        //id del tipo de ciclo de donde proviene
        cicloId: null,

        //seccion del ciclo
        cicloData: null,
        cicloExpand: true,

        //estado de las tarifas a cargar del back
        tarifaEstado: "1",

        //history
        loadingHistory: false,
        showHistory: false,
        historyData: null
    }),

    methods: {
        toogleSearch: function() {
            this.searchShow = !this.searchShow
        },

        loadData(estado) {
            this.loading = true
            this.$store
                .dispatch("LOAD_TARIFAS", {
                    cicloID: this.cicloId,
                    filter: this.filter.search,
                    tarifaEstado: estado
                })
                .then(result => {
                    this.loading = false
                    this.totalItems = result
                })
        },

        openForm(item) {
            if (item !== null) {
                this.title = "Modificar tarifa"
                this.editItem = item
            } else {
                this.title = "Nueva tarifa"
            }
            this.showForm = true
        },

        closeForm() {
            this.showForm = false
            this.editItem = null
        },

        deleteItem(props) {
            this.menuLocked = true
            this.deleteTarifaConfirmId = props.item.id
            props.expanded = true
        },

        deleteItemConfirm(props) {
            if (this.deleteTarifaConfirmId === props.item.id) {
                this.loading = true
                this.$store.dispatch("DELETE_TARIFA", props.item).then(() => {
                    this.loading = false
                    this.menuLocked = false
                    this.deleteTarifaConfirmId = ""
                    props.expanded = !props.expanded
                })
            }
        },

        deleteItemCancel(props) {
            this.menuLocked = false
            this.deleteTarifaConfirmId = ""
            props.expanded = !props.expanded
        },

        getCicloSeccionIcon() {
            return this.cicloExpand ? "fa-angle-left" : "fa-angle-right"
        },

        loadCiclo() {
            this.loadData(this.tarifaEstado)
        },

        loadHistory(item) {
            this.loadingHistory = true

            let historyClassName = Util.getHistoryClassName("Tarifa")
            this.$store.commit("SET_HISTORIALES_TIME_LINE_PAG", { page: 1 })
            this.$store
                .dispatch("LOAD_HISTORIALES_TIME_LINE", { class: historyClassName, class_id: item.id })
                .then(response => {
                    if (response) {
                        this.historyData = this.$store.getters.HISTORIALES_TIME_LINE.historiales
                        this.showHistory = true
                        this.loadingHistory = false
                    } else {
                        this.loadingHistory = false
                    }
                })
        },

        searchData: _.debounce(function() {
            this.loadData(this.tarifaEstado)
        }, 1000),

        getChipColor(item) {
            switch (item.estado) {
                case 1:
                    return "success lighten-1"
                case 0:
                    return "grey lighten-1"
            }
        },

        getIconColor(data) {
            switch (data.item.value) {
                case "1":
                    return "black"
                case "2":
                    return "success lighten-1"
                case "3":
                    return "grey lighten-1"
                default:
                    return "black"
            }
        }
    },

    computed: {
        ...mapGetters(["TARIFAS"]),

        pagination: {
            get: function() {
                return this.$store.getters.TARIFAS_PAG
            },
            set: function(value) {
                this.$store.commit("SET_TARIFAS_PAG", value)
            }
        },
        searchTerm() {
            return this.filter.search
        }
    },

    watch: {
        pagination: {
            handler() {
                this.loadData(this.tarifaEstado)
            },
            deep: true
        },
        searchTerm() {
            this.searchData()
        }
    },

    created() {
        if (this.cicloParam) {
            localStorage.setItem("ciclo_id", JSON.stringify(this.cicloParam.id))
        }
    },

    mounted() {
        let ciclo = localStorage.getItem("ciclo_id")
        this.cicloId = JSON.parse(ciclo)

        this.$store.dispatch("LOAD_CICLO_DETAILS_TARIFAS", { id: this.cicloId }).then(result => {
            if (result) {
                this.cicloData = result
            }
        })
    }
}
</script>
